<!-- zoom飘窗 -->
<template>
 <div class="application-piaochuang-wrap" v-if="isShowPiaoChuang">
  <div class="application-piaochuang-main">
    <p>因Zoom近期出台的阶段性限制政策，导致不同客户端Zoom链接启动失败，为解决此问题（无需卸载原Zoom软件），请点击查看更多下载对应版本的Zoom插件及使用说明</p>
    <Button class="paiochuang-btn paiochuang-margin" @click="open(false)">查看更多</Button>
    <Button class="paiochuang-btn" @click="isShowPiaoChuang = false">关闭</Button>
  </div>
 </div>
</template>
<script>
export default {
  name: '',
  components: {},
  data () {
    return {
      isShowPiaoChuang: true
    }
  },
  computed: {},
  mounted () {
    this.$Notice.config({
      top: 100,
      duration: 0
    })
  },
  methods: {
  // 飘窗
    open (nodesc) {
      this.$Notice.open({
        title: ' Zoom 插件与使用教程下载',
        desc: nodesc ? '' : "Windows PC 版 Zoom 插件：<a href='https://zlrvaleon-om.oss-cn-beijing.aliyuncs.com/docs/zoom/Zoom%20add-on%20for%20Windows%20PC.exe' target='_blank'>下载</a><br>Mac 版 Zoom 插件：<a href='https://zlrvaleon-om.oss-cn-beijing.aliyuncs.com/docs/zoom/Zoom%20add-on%20for%20Mac.zip' target='_blank'>下载</a><br>Zoom 插件使用教程：<a href='https://zlrvaleon-om.oss-cn-beijing.aliyuncs.com/docs/zoom/Zoom%20add-on%20Instruction.pdf' target='_blank'>下载</a>"
      })
    }
  }
}
</script>
<style lang='less' scoped>
.application-piaochuang-wrap {
  position:fixed;
  left:50%;
  top:65px;
  transform: translateX(-50%);
  z-index: 102;
  background-color:#ffffff;
  width:100%;
  .application-piaochuang-main{
    padding:0 20px;
    display:flex;
    justify-content: center;
    align-items: center;
    font-size:12px;
    color:red;
  }
  .paiochuang-btn{
    border:0;
    color:#6589dd;
    text-decoration: underline;
  }
  .paiochuang-margin {
    margin:0 15px;
  }
}

</style>
